"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumContentWebPlayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PremiumContentMetadata_1 = require("../../Metadata/PremiumContentMetadata");
const StoryWebPlayer_1 = require("../StoryWebPlayer");
/** Premium Content Web Player should be used for displaying Premium content on the Web. */
function PremiumContentWebPlayer(props) {
    const [currentOnPlaySnapIndex, setCurrentPlaySnapIndex] = (0, react_1.useState)(0);
    const [shouldShowReplayStory, setShouldShowReplayStory] = (0, react_1.useState)(false);
    const { indexChanged, onStoryEnded } = props;
    (0, react_1.useEffect)(() => {
        indexChanged?.(currentOnPlaySnapIndex);
    }, [currentOnPlaySnapIndex, indexChanged]);
    const canPlayNext = props.story.snaps
        ? currentOnPlaySnapIndex < props.story.snaps.length - 1
        : false;
    const canPlayPrev = currentOnPlaySnapIndex > 0;
    const playNextSnap = (0, react_1.useCallback)(() => {
        if (!canPlayNext) {
            setShouldShowReplayStory(true);
            onStoryEnded?.();
        }
        else {
            setCurrentPlaySnapIndex((prevSnapPlayIndex) => prevSnapPlayIndex + 1);
        }
    }, [canPlayNext, onStoryEnded]);
    const playPrevSnap = (0, react_1.useCallback)(() => {
        if (!canPlayPrev) {
            return;
        }
        setShouldShowReplayStory(false);
        setCurrentPlaySnapIndex((prevSnapPlayIndex) => prevSnapPlayIndex - 1);
    }, [canPlayPrev]);
    const onPlayEnded = (0, react_1.useCallback)(() => {
        playNextSnap();
    }, [playNextSnap]);
    const replayStory = (0, react_1.useCallback)(() => {
        setCurrentPlaySnapIndex(0);
        setShouldShowReplayStory(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(StoryWebPlayer_1.StoryWebPlayer, { ...props, shouldTogglePlayWithFocus: true, allowReporting: false, isMuted: true, isOnPlay: !props.isMobile, onPlayEnded: onPlayEnded, replayStory: replayStory, playPrevSnap: playPrevSnap, playNextSnap: playNextSnap, shouldShowReplayStory: shouldShowReplayStory, currentOnPlaySnapIndex: currentOnPlaySnapIndex, canPlayNextSnap: canPlayNext, canPlayPrevSnap: canPlayPrev, autoPlay: props.focused, shouldShowPosterImage: true, children: props.customMetadataEl || (0, jsx_runtime_1.jsx)(PremiumContentMetadata_1.PremiumContentMetadata, {}) }));
}
exports.PremiumContentWebPlayer = PremiumContentWebPlayer;
//# sourceMappingURL=PremiumContentWebPlayer.js.map